<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-5 px-7">
    <div class="header">
      <h1 class="title">
        {{ $t(template.comUsesTitle) }}
        <span v-if="itemMaxLength" class="max-length-guide">
          {{ $t('최대') }} {{ $t(itemMaxLength) }}
          {{ $t(' 개 입력 가능') }}</span
        >
      </h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideComUses"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <v-row v-if="obj">
          <v-col cols="12" class="col-md-11">
            <v-row>
              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="itemDirectInput('usesGubun') == 'Y'"
                  v-model="obj.usesGubun"
                  :items="itemArray('usesGubun')"
                  :label="itemLabel('usesGubun')"
                  outlined
                  dense
                  :readonly="isReadonly"
                  v-maxlength="'uses_gubun'"
                  :rules="[rules.required('usesGubun', true)]"
                />
              </v-col>
              <v-col cols="12" class="col-md-3">
                <i-text-field
                  v-maxlength="'uses_name'"
                  v-model="obj.usesName"
                  :label="itemLabel('usesName')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('usesName', true),
                    rules.maxlength('usesName'),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>
              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="itemDirectInput('usesLevel') == 'Y'"
                  v-model="obj.usesLevel"
                  v-maxlength="'uses_level'"
                  :items="itemArray('usesLevel')"
                  :label="itemLabel('usesLevel')"
                  outlined
                  dense
                  :readonly="isReadonly"
                  :rules="[rules.required('usesLevel', true)]"
                />
              </v-col>

              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="itemDirectInput('usesTerm') == 'Y'"
                  v-model="obj.usesTerm"
                  v-maxlength="'uses_term'"
                  :items="itemArray('usesTerm')"
                  :label="itemLabel('usesTerm')"
                  outlined
                  dense
                  :readonly="isReadonly"
                  :rules="[rules.required('usesTerm', true)]"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-8 mb-md-0"
            :class="colclass"
          >
            <i-btn elevation="0" color="primary" block @click="add">저장</i-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm">
        <v-row
          v-for="(item, i) in comUsesArray"
          :key="'comuserow' + i"
          class="mt-4"
        >
          <v-col cols="12" :class="{ 'col-md-11': !isReadonly }">
            <v-row>
              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="itemDirectInput('usesGubun') == 'Y'"
                  v-maxlength="'uses_gubun'"
                  v-model="item.usesGubun"
                  :items="itemArray('usesGubun')"
                  :label="itemLabel('usesGubun')"
                  outlined
                  dense
                  @change="save"
                  :readonly="isReadonly"
                  :rules="[rules.required('usesGubun')]"
                />
              </v-col>
              <v-col cols="12" class="col-md-3">
                <i-text-field
                  v-maxlength="'uses_name'"
                  v-model="item.usesName"
                  :label="itemLabel('usesName')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('usesName'),
                    rules.maxlength('usesName'),
                  ]"
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="itemDirectInput('usesLevel') == 'Y'"
                  v-maxlength="'uses_level'"
                  v-model="item.usesLevel"
                  :items="itemArray('usesLevel')"
                  :label="itemLabel('usesLevel')"
                  outlined
                  dense
                  @change="save"
                  :readonly="isReadonly"
                  :rules="[rules.required('usesLevel')]"
                />
              </v-col>
              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="itemDirectInput('usesTerm') == 'Y'"
                  v-maxlength="'uses_term'"
                  v-model="item.usesTerm"
                  :items="itemArray('usesTerm')"
                  :label="itemLabel('usesTerm')"
                  outlined
                  dense
                  @change="save"
                  :readonly="isReadonly"
                  :rules="[rules.required('usesTerm')]"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-6 mb-md-0"
            :class="colclass"
            v-if="!isReadonly"
          >
            <i-btn
              elevation="0"
              color="normal"
              block
              outlined
              @click="remove(i)"
              >삭제</i-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { DialogMixin } from '@/mixin/dialog.js';
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import { snack } from '@/plugins/dialog/api';
export default {
  components: { DirectInputSelect },
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },
    itemLabel: {
      type: Function,
      default: () => {},
    },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.comUses?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.comUses?.oMaxLength ||
        this.opts.comUses?.oMaxLength > this.comUsesArray.length
      );
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
  },
  mixins: [DialogMixin],
  data: () => ({
    obj: null,
    itemDelimeter: '#',
    comUses: '',
    comUsesArray: [],
    itemSeq: 1,
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
    isSetWord: false,
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    setting: function() {
      if (this.template.typeComUses) this.comUses = this.template.typeComUses;
      this.settingData();
      this.obj = this.defaultObj();
    },
    settingData: function() {
      if (this.info && this.info.comUses && this.info.comUses.length > 0) {
        this.comUsesArray = this.info.comUses.reduce((a, c) => {
          a.push({
            seq: c.id.seq,
            usesGubun: c.usesGubun,
            usesName: c.usesName,
            usesTerm: c.usesTerm,
            usesLevel: c.usesLevel,
          });
          return a;
        }, []);
        this.itemSeq =
          this.comUsesArray.reduce((a, c) => {
            a = a > c.seq ? a : c.seq;
          }, this.itemSeq) + 1;
      }
    },
    defaultObj: function() {
      return {
        seq: this.itemSeq++,
        usesGubun: '',
        usesName: '',
        usesTerm: '',
        usesLevel: '',
      };
    },
    add: function() {
      if (!this.canAdd)
        return this.$showAlert(
          '최대 입력 가능 갯수 : ' + `${this.opts.comUses.oMaxLength}`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },
    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.comUses &&
        this.opts.comUses.oRequireYn &&
        this.opts.comUses.oRequireYn == 'Y' &&
        this.comUsesArray.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    save: function(i) {
      var tmp = i === -1 ? this.obj : this.comUsesArray[i];
      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;

      const id = {
        annoId: this.$route.params.annoId,
        seq: tmp.seq ?? this.comUsesArray.length,
      };
      const p = {
        id: id,
        usesName: tmp.usesName,
        usesGubun: tmp.usesGubun,
        usesLevel: tmp.usesLevel,
        usesTerm: tmp.usesTerm,
      };

      this.$emit('save', p, 'comUses', i);
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('COM_USES SAVE FAIL');
      } else {
        snack.info(
          `${this.$t(this.template.comUsesTitle)}` +
            this.$t('이 저장 되었습니다.'),
        );
        if (i === -1) {
          this.comUsesArray.push(this.obj);
          this.obj = this.defaultObj();
          this.$refs.saveForm.resetValidation();
        }
      }
    },
    delete: function(i) {
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.comUsesArray[i].seq,
      };
      this.$emit('delete', p, 'comUses', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('COM_USES DELETE FAIL');
      } else {
        snack.danger(
          `${this.$t(this.template.comUsesTitle)}` +
            this.$t('이 삭제 되었습니다.'),
        );
        this.comUsesArray.splice(i, 1);
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
